import { Link } from "react-router-dom";

import { useScrollReveal } from "../../../hooks/useScrollReveal";
import "./Cta01.css";
import Button01 from "../../core/Button01";

function Cta01() {
  const { ref, isVisible } = useScrollReveal();

  const handleScrollToForm = (e) => {
    e.preventDefault();
    const formElement = document.getElementById("Form01");
    if (formElement) {
      formElement.scrollIntoView({
        behavior: "smooth",
        block: "center",
      });
    }
  };

  return (
    <div
      ref={ref}
      className={`Cta01 section section-reveal ${isVisible ? "section--visible" : ""}`}
      id="Cta01"
    >
      <div className="container">
        <div className="Cta01-box">
          <h2>Your content deserves protection.</h2>
          <p>
            Protect your content and the brand you’ve worked hard to build. We
            take care of the rest.
          </p>

          <Button01 />
        </div>
      </div>
    </div>
  );
}

export default Cta01;
